import APIUtils from '@spothero/utils/api';
const ReviewsAPI = {
    get({ facilityId, page = 1 }) {
        return APIUtils.get('reviews/', {
            facility_id: facilityId,
            page,
        });
    },
};
export default ReviewsAPI;
